export enum NotificationType {
  Reward     = 'Reward',
  AppInsight = 'App Insight'
}
